import { enforce } from 'vest';
import isEmail from 'validatorIsEmail';

enforce.extend({ isEmail });

const validationMappings = {
    LengthValidator: (value, args) => {
        return enforce(value)
            .longerThanOrEquals(args.MinLength)
            .shorterThanOrEquals(args.MaxLength);
    },
    NotNullValidator: value => enforce(value).isNotNull(),
    NotEmptyValidator: value => enforce(value).isNotBlank(),
    EqualValidator: (value, args, data) => {
        if (value === undefined || value === null ||
            data === undefined || data === null) {
            return;
        }

        let comparisonValue = args.ComparisonValue;
        if (args.ComparisonProperty !== null) {
            comparisonValue = data[args.ComparisonProperty];
        }

        return enforce(value).equals(comparisonValue);
    },
    NotEqualValidator: (value, args) => enforce(value).notEquals(args.ComparisonValue),
    MaximumLengthValidator: (value, args) => {
        if (value === undefined || value === null){
            return;
        }

        return enforce(value).shorterThanOrEquals(args.MaxLength);
    },
    MinimumLengthValidator: (value, args) => enforce(value).longerThanOrEquals(args.MinLength),
    EmailValidator: value => {
        return enforce(value).isEmail();
    },
    RegularExpressionValidator: (value, args) => {
        var regex = new RegExp(args.Pattern);
        return enforce(value).matches(regex);
    }
};

export { validationMappings };